/**
 * this code will run on all tutorials action pages
 * pages_controller
 * @see [1] - documentation_controller.rb
 */
import './show'; // [1]
import 'views/tutorials/tutorials.scss';
import TutorialsShow from 'views/tutorials/show';

document.addEventListener('DOMContentLoaded', function tutorialContentLoaded() {
  const show = new TutorialsShow();
  show.init();
});
